/**
 * API: Reporte de Estudiantes Nuevo Ingreso (Administracion del Sistema).
 *
 * Endpoint: GET /api/escolar/reportes/estudiantes-nuevo-ingreso/
 *
 * Filtros soportados:
 *  - id_ciclo_escolar (req)
 *  - id_campus        (opc)
 *  - id_seccion       (opc)
 *  - id_programa      (opc)
 *  - page             (opc, default 1)
 *  - page_size        (opc, default 10)
 *  - all              (opc, '1' devuelve todos sin paginar)
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getAuthToken() {
  return localStorage.getItem('authToken');
}

function getHeaders() {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function getReporteEstudiantesNuevoIngreso({
  id_ciclo_escolar,
  id_campus,
  id_seccion,
  id_programa,
  page = 1,
  page_size = 10,
  all = false,
} = {}) {
  if (!id_ciclo_escolar) {
    throw new Error("El parametro 'id_ciclo_escolar' es requerido.");
  }

  const qs = new URLSearchParams();
  qs.set('id_ciclo_escolar', String(id_ciclo_escolar));
  if (id_campus !== undefined && id_campus !== null && id_campus !== '' && id_campus !== 'todos') {
    qs.set('id_campus', String(id_campus));
  }
  if (id_seccion !== undefined && id_seccion !== null && id_seccion !== '' && id_seccion !== 'todos') {
    qs.set('id_seccion', String(id_seccion));
  }
  if (id_programa !== undefined && id_programa !== null && id_programa !== '' && id_programa !== 'todos') {
    qs.set('id_programa', String(id_programa));
  }
  if (all) {
    qs.set('all', '1');
  } else {
    qs.set('page', String(page));
    qs.set('page_size', String(page_size));
  }

  const url = `${API_BASE}/escolar/reportes/estudiantes-nuevo-ingreso/?${qs.toString()}`;
  const res = await fetch(url, { headers: getHeaders(), cache: 'no-store' });

  if (!res.ok) {
    let errorMsg = `Error ${res.status} al obtener el reporte`;
    try {
      const errorData = await res.json();
      errorMsg = errorData.error || errorMsg;
    } catch (_) { /* ignore */ }
    throw new Error(errorMsg);
  }

  return await res.json();
}

export default getReporteEstudiantesNuevoIngreso;
